import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import QRScan from "../pages/qr-scan";

import Idle from "../pages/idle";
import CanSelection from "../pages/digital-graffiti/can-selection";
import GraffitiArtwork from "../pages/digital-graffiti/graffiti-artwork";
import KioskSessionManager from "../compoment/KioskSessionManager";
import GlobalPinHandler from "../compoment/GlobalPinHandler";
import PWAInstallPrompt from "../compoment/PWAInstallPrompt";

const AppRoutes = () => {
  return (
    <Router>
      <KioskSessionManager />
      <GlobalPinHandler />
      <PWAInstallPrompt />
      <Routes>
        {/* ================= COMMON ROUTE ================= */}
        <Route path="/" element={<Idle />} />
        <Route path="/qr-scan" element={<QRScan />} />

        {/* ================= DIGITAL GRAFFITI ROUTE ================= */}
        <Route path="/digital-graffiti" element={<CanSelection />} />
        <Route path="/digital-graffiti-art" element={<GraffitiArtwork />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
